import { ApiUtility } from "../../../Utilities/ApiUtility.axios";

export enum docType {
  GSTCertificate = 1,
  PAN,
  TAN,
  CIN,
  UdyamRegistrationCertificate,
  ImportExportCertificate,
  ISOQualityCertificate,
  ISICertificate,
  AuditedBalanceSheet,
  MemorandumOfAssociation,
  IncorporationCertificate,
  FactoryRegistrationCertificate,
  BankSolvencyForm,
  BankDetailWithCancelCheque,
  PlantMachineryList,
  TestingEquipmentsListWithCalibrationStatus,
  ClientageDetail,
  TurnoverDetails,
  PreviousSuppliesDetail,
  ListOfDirectorsPartners,
  ProductDetails,
}

export enum Fields {
  Number = 1,
  Upload,
  ExpiryDate,
  BankName,
  Branch,
  AccountNo,
  AccountHolderName,
  AccountType,
  IFSC,
  Name,
  CalibrationStatus,
  Since,
  Last1Year,
  Last2Year,
  Last3Year,
  IssuedOn,
  Date,
  PONo,
}
class InventoryMasterService {
  private route = "v1/API/Acc_Documents";

  saveInvMaster = (document: any, id: any) =>
    ApiUtility.post(`${this.route}/${id}`, document);

  getMasterDetails = (
    clientId: string | undefined,
    search: string,
    sortCol: any,
    sortDir: any,
    showInList: any
  ) =>
    ApiUtility.get(
      `${this.route}/GetList?clientId=${clientId}&search=${search}&sortCol=${sortCol}&sortDir=${sortDir}&showInList=${showInList}`
    );
}

export default new InventoryMasterService();
